// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3bdTP","fileBtn":"File_fileBtn__NxX3T","closeBtn":"File_closeBtn__1TlWW","fileSelected":"File_fileSelected__mLhpN","disabled":"File_disabled__3J0r_"};